import styled from 'styled-components'

export const StyledProductNotes = styled.p`
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 165%;
  margin: 5px 0 0;
`

export const StyledProductNotesToggle = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-left: 2px;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  white-space: nowrap;
  color: #282832;
`
